import { localizedText } from '../../common-js/LanguageMap';
import { getGraphicOrganizerData, } from '../../common-js/GraphicOrganizerData';
// import { getGraphicOrganizerTextBoxesEs } from '../../common-js/DynamicData';

export default function ($scope, $rootScope, $state, $log, $timeout, addonFactory, DrawpService) {
    $scope.localizedText = localizedText;
    $scope.assetPath = 'assets/graphic/';
    $scope.stateTitle = $scope.localizedText('GRAPHIC_ORGANIZERS');
    $scope.backState = 'addonAppIndex';
    $scope.stateClass = 'graphic-organizers-item';
    $scope.placeholderFeature = true;
    $scope.toolId = '6603b1a0e4b0f12b1a345678';
    $scope.selectSizeHelperText = $scope.localizedText('SELECT_SLIDE_SIZE');

    let serverUrl = 'https://app.drawpforschool.com/';
    let elementTheme = null;
    let elementPlaceholder = null;
    let elPageSize = null;

    $scope.supportedPageSize = [
        { 'val': 'widescreen', 'text': 'Wide Screen', 'width': 960, 'height': 540, textboxXScale: 1, textboxYScale: 1 },
        { 'val': 'overhead', 'text': 'Overhead', 'width': 720, 'height': 540, textboxXScale: .75, textboxYScale: 1 },
        { 'val': '4:3', 'text': 'On Screen Show (4:3)', 'width': 720, 'height': 540, textboxXScale: .75, textboxYScale: 1 },
        { 'val': '16:9', 'text': 'On Screen Show (16:9)', 'width': 720, 'height': 405, textboxXScale: .75, textboxYScale: .75 },
        { 'val': '16:10', 'text': 'On Screen Show (16:10)', 'width': 720, 'height': 450, textboxXScale: .75, textboxYScale: .83 } //factor is used to adjust the textbox size since textbox are maped for widescreen
    ];

    let presentationId = null;

    let subscriptionInfoDialog = null;
    let elementCancelSub = null;

    $scope.error = null;

    const progressText = $scope.localizedText('LOADING');
    $scope.progress = progressText;
    $scope.enableReload = true;

    const ERROR_MESSAGE = addonFactory.API_CALL_ERROR.GENERICERROR;

    $scope.language = 'en';
    $scope.loadingMessage = progressText;
    $scope.isNavCollapseableHidden = false;
    $scope.formData = '';
    $scope.dataList = [];
    $scope.bundle = 'Comprehension';
    $scope.disabledFeature = true;
    $scope.placeholderToolTip = false;
    $scope.isEnglishListActive = true;
    $scope.subscription_days = 100;
    $scope.subscription = null;
    $scope.checkboxPremium = true;
    $scope.checkboxFree = true;
    $scope.userEmail = '';
    $scope.serverToken = '';
    $scope.alert_multi_account = false;
    $scope.pageSize = 'widescreen';
    $scope.pageSizeHideShowToggle = true;
    $scope.isPageSizeAutoDetected = false;
    $scope.loginDialogMessage = '';
    $scope.isLoginDialogOpen = false;

    const showProgress = (show, message) => {

        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;

            if (show) {
                $scope.progress = message;
            }
        });
    };

    const showError = (show, message) => {
        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;

            if (show) {
                $scope.error = message;
                if (message === addonFactory.API_CALL_ERROR.QUOTAERROR) {
                    $scope.enableReload = false;
                } else {
                    $scope.enableReload = true;
                }
            }
        });
    };

    const errorHandler = (error) => {
        const errorResp = addonFactory.errorHandler(error, $scope);
        showError(true, errorResp);
    };

    const loadSelectedBundle = () => {

        if ($scope.formData === '') {
            return;
        }

        $timeout(() => {

            $scope.bundle = elementTheme.value;

            if ($scope.bundle === 'All') {
                $scope.dataList = $scope.formData.bundles.filter(k => {
                    return k.language === $scope.language;
                });
            } else {
                $scope.dataList = $scope.formData.bundles.filter(k => {
                    return k.language === $scope.language && k.bundle_name === $scope.bundle;
                });
            }

            let i = 1;
            $scope.dataList.forEach((data, index) => {
                data.canvas_list.forEach((canvas, indexInner) => {
                    $scope.dataList[index].canvas_list[indexInner].number = i;
                    i += 1;
                });
            });
        });
        showProgress(false, '');
    };

    $scope.onFilterToggle = () => {
        $scope.isNavCollapseableHidden = !$scope.isNavCollapseableHidden;

        switch ($scope.bundle) {
            case 'All':
                elementTheme.selectedIndex = 0;
                break;
            case 'Comprehension':
                elementTheme.selectedIndex = 1;
                break;
            case 'Flow':
                elementTheme.selectedIndex = 2;
                break;
            case 'Maps':
                elementTheme.selectedIndex = 3;
                break;
            case 'Story':
                elementTheme.selectedIndex = 4;
                break;
            case 'Tables':
                elementTheme.selectedIndex = 5;
                break;
            case 'Time':
                elementTheme.selectedIndex = 6;
                break;
            case 'Wheels':
                elementTheme.selectedIndex = 7;
                break;
            default:
                elementTheme.selectedIndex = 0;
        }

        angular.element('#checkbox-premium').prop('checked', $scope.checkboxPremium);
        angular.element('#checkbox-free').prop('checked', $scope.checkboxFree);
    };

    $scope.onFilterChangedToggle = () => {

        $scope.bundle = elementTheme.value;
        // $scope.checkboxPremium = angular.element('#checkbox-premium').is(':checked');
        // $scope.checkboxFree = angular.element('#checkbox-free').is(':checked');
        $scope.onFilterToggle();
        loadSelectedBundle();
    };

    $scope.onLanguageToggle = () => {

        $scope.isEnglishListActive = !$scope.isEnglishListActive;

        if ($scope.isEnglishListActive) {
            $scope.language = 'en';
        } else {
            $scope.language = 'es';
        }
        // $scope.handleDefaultValueEvent();
        loadSelectedBundle();
    };

    const detectSlideSize = async () => {
        try {
            const size = await DrawpService.getPresentationSlideSize();
            if (size) {
                console.log("Detected presentation slide size:", size);
                let bestMatch = $scope.supportedPageSize.find((item) =>
                    item.width === size.width && item.height === size.height
                );

                if (!bestMatch) {
                    bestMatch = $scope.supportedPageSize.find((item) =>
                        Math.abs(item.width - size.width) < 5 && Math.abs(item.height - size.height) < 5
                    );
                }

                if (bestMatch) {
                    return await $timeout(() => {
                        $scope.pageSize = bestMatch.val;
                        $scope.pageSizeHideShowToggle = false;
                        $scope.isPageSizeAutoDetected = true;
                        return bestMatch;
                    });
                }
            }
        } catch (error) {
            console.error("Error auto-detecting slide size:", error);
        }
        return null;
    };

    const init = () => {
        showProgress(true, progressText);
        DrawpService.getGraphicOrganiser().then((text) => {
            // console.log(text.data);
            $scope.formData = text.data;
            $scope.language = $scope.formData.defaults.language;
            $scope.placeholder = $scope.formData.defaults.placeholder;
            $scope.placeholderToolTip = $scope.formData.defaults.graphic_organizer_tooltip;

            $scope.subscription_days = $scope.formData.subscription_expired;
            $scope.subscription = $scope.subscription_days != null && $scope.subscription_days > 0;

            $scope.initValueLanguage = $scope.formData.defaults.language;
            $scope.initValuePlaceholder = $scope.formData.defaults.placeholder;
            $scope.initValueAudio = $scope.formData.defaults.audio;

            if ($scope.language === 'en') {
                $scope.isEnglishListActive = true;
            } else {
                $scope.isEnglishListActive = false;
            }

            // if ($scope.placeholder) {
            elementPlaceholder.checked = true;
            // } else {
            //     elementPlaceholder.checked = false;
            // }

            // if ($scope.placeholderToolTip) {
            // angular.element('#placeholder-popover').popover('show');
            // setPlaceholderPopoverTrigger();
            // }

            loadSelectedBundle();
        }).catch((error) => {
            console.log(error);
            // if (text == null) {
            showError(true, 'There was an error while loading this page');
            // } else if (text === 401 || text === '401') {
            //     showError(true, `This Drawp Add-On tool is not available for your account. You can explore the tool 30 days for free by <a target="blank" href="${serverUrl
            //         }teacher/search-school/google/">signing up</a>. Contact <a href = "mailto: sales@drawpforschool.com">sales@drawpforschool.com</a> for more details or visit <a target="blank" href="${serverUrl
            //         }#pricing">pricing</a>.`);
            // }
        });
    };

    $scope.getPremiumClass = (data) => {
        if ($scope.subscription) {
            return false;
        }
        try {
            if (data.premium) {
                return true;
            }
            return false;

        } catch (error) {
            return false;
        }
    };

    $scope.getPremiumClassForAll = (data) => {
        try {
            if (data.premium) {
                return true;
            }
            return false;

        } catch (error) {
            return false;
        }
    };

    $scope.premiumFilter = (item) => {
        if ($scope.checkboxPremium && $scope.checkboxFree) {
            return true;
        }
        if (!$scope.checkboxPremium && $scope.checkboxFree) {
            try {
                if (item.premium) {
                    return false;
                }
                return true;

            } catch (error) {
                return true;
            }
        } else if ($scope.checkboxPremium && !$scope.checkboxFree) {
            try {
                if (item.premium) {
                    return true;
                }
                return false;

            } catch (error) {
                return false;
            }
        }
        return false;
    };

    angular.element(document).ready(() => {

        // presentationId = document.getElementById('presentationId').textContent.trim();
        // $scope.userEmail = document.getElementById('userEmail').textContent.trim();
        // $scope.serverToken = document.getElementById('serverToken').textContent.trim();

        // if (addonFactory.isMultiAccountActive() != null) {
        //     $scope.alert_multi_account = addonFactory.isMultiAccountActive();
        // }

        subscriptionInfoDialog = mdc.dialog.MDCDialog.attachTo(document.querySelector('#subscription_info_dialog'));

        // angular.element('#placeholder-popover').popover({
        //     container: 'body',
        //     placement: 'top',
        //     trigger: 'click focus',
        //     html: true,
        //     title: 'Text box placeholders <a href="javascript:void(0);" class="close dfs-addon-popover-close" data-dismiss="alert">&times;</a>',
        //     content: '<div class="media"><div class="media-body"><p>Predefined text boxes will be added when this switch is ON. You can use the switch to adjust this setting according to your preferences.</p></div></div>'
        // });

        // angular.element('#placeholder-popover').popover('hide');

        // angular.element(document).on('click', '.popover .close', () => {
        //     angular.element('#placeholder-popover').popover('hide');
        //     angular.element('#placeholder-popover').popover('disable');
        // });

        // angular.element(document).click(() => {
        //     angular.element('#placeholder-popover').popover('hide');
        //     angular.element('#placeholder-popover').popover('disable');
        // });

        DrawpService.gAPageview('graphic-organizers', 'Graphic Organizers', null, null, addonFactory.getActiveAccountEmail(), $scope.serverToken);

        elementTheme = mdc.select.MDCSelect.attachTo(document.querySelector('#theme'));
        elementTheme.selectedIndex = 0;

        elementPlaceholder = mdc.switchControl.MDCSwitch.attachTo(document.querySelector('#audio-switch'));
        elementPlaceholder.checked = true;

        elPageSize = mdc.select.MDCSelect.attachTo(document.querySelector('#slide-page-setup'));
        elPageSize.listen('MDCSelect:change', () => {
            $scope.pageSize = elPageSize.value;
        });

        detectSlideSize();
        init();
    });

    $scope.checkIfMultiple = (data) => {
        if ($scope.bundle !== 'All') {
            return true;
        }
        try {
            if (data.multiple) {
                return false;
            }
            return true;

        } catch (error) {
            return true;
        }
    };

    $scope.onPurchaseClick = ($event, url) => {
        if ($event) {
            $event.stopPropagation();
        }
        if (!DrawpService.isLoggedIn()) {
            $scope.loginDialogMessage = 'Please login to purchase this tool.';
            $scope.isLoginDialogOpen = true;
        } else {
            DrawpService.gAPurchaseButtonSelectedEvent(0, $scope.language, $scope.bundle, url, $scope.serverToken);
            $state.go('payment', {
                tool: "0",
                language: $scope.language,
                data1: $scope.bundle,
                data2: url
            });
        }
    };

    $scope.getThumbnailUrl = (data) => {
        if ($scope.placeholder) {
            if (data.tp != null) {
                return data.tp;
            } if (data.th != null) {
                return data.th;
            }
            return data.datastore_url;

        }
        if (data.th != null) {
            return data.th;
        }
        return data.datastore_url;
    };

    // const insertText = (slideId, canvasId, textBoxData) => {
    //     const textboxSwitch = true;
    //     // const textboxSwitch = elementPlaceholder.checked;
    //     google.script.run
    //         .withSuccessHandler(() => {
    //             showProgress(false, '');
    //             $scope.snackBarUtil(true, 'Slide has been added at the end of the presentation.', 'Ok');
    //         })
    //         .withFailureHandler(errorHandler)
    //         .insertTextBox(slideId, canvasId, $scope.language, textboxSwitch, presentationId, textBoxData);
    // };


    // mapTextBoxesToGraphicOrganizer = ()  => {

    // mapping textboxes to canvas
    // let a= []; 
    // let i = 0; 
    // let j = 0;
    // // let textboxes = getGraphicOrganizerTextBoxesEs();
    // // console.log(textboxes.length);
    // getGraphicOrganizerData().bundles.forEach(bundle => {

    //     if (bundle.language =='es') {

    //         bundle.canvas_list.forEach(canvas => {
    //             // console.log(textboxes[0]['textbox']);

    //             canvas['textbox'] = getGraphicOrganizerTextBoxesEs()[i]['textbox'];

    //             if (![16, 22, 24].includes(j + 1)) {
    //                 i++;
    //             }

    //             j++

    //         });
    //     }
    //     a.push(bundle);

    // })
    // console.log(JSON.stringify(a))
    // }

    $scope.insertImage = async (canvas, bundleName) => {
        if (!DrawpService.isLoggedIn()) {
            $scope.loginDialogMessage = 'Please login to use this tool.';
            $scope.isLoginDialogOpen = true;
            return;
        }

        await detectSlideSize();

        const findPageSetup = $scope.supportedPageSize.find((item) => item.val === $scope.pageSize);

        let isPremium = false;

        try {
            isPremium = canvas.premium;
            if (isPremium == null) {
                isPremium = false;
            }
        } catch (error) {
            isPremium = false;
        }

        if (!$scope.getPremiumClass(canvas)) {
            showProgress(true, progressText);
            const textboxes = getTextBoxes(canvas.canvas_id, $scope.language);

            DrawpService.addBackgroundImageToSlideV3(canvas.datastore_url, findPageSetup.width, findPageSetup.height).then((response) => {
                DrawpService.addTextBoxesWithStyles(textboxes, findPageSetup.textboxXScale, response, findPageSetup.textboxYScale).then((response) => {
                    DrawpService.gAGraphicOrganizerAddEvent('insert_graphic_organizer', canvas.canvas_id, canvas.datastore_url, $scope.language, bundleName, elementPlaceholder.checked, "", $scope.initValueLanguage, $scope.initValuePlaceholder, $scope.bundle, $scope.subscription, isPremium, $scope.serverToken);

                    showProgress(false, '');
                    $scope.launchSnackBar($scope.localizedText('SLIDE_ADDED_TO_PRESENTATION'), 'Ok', true);
                }).catch((error) => {
                    console.log(error);
                    showProgress(false, '');
                    errorHandler(error);
                });
            });
        }
    };

    $scope.handleLanguageChangeEvent = (language) => {
        $scope.isNavCollapseableHidden = false;
        // google.script.run
        //     .withSuccessHandler((text) => {
        //         if (text != null) {
        //             const languageData = JSON.parse(text);
        //             $scope.language = languageData.user.language;
        //             loadSelectedBundle();
        //         }
        //     })
        //     .withFailureHandler(() => {
        //         $scope.language = language;
        //         loadSelectedBundle();
        //     })
        //     .setLanguage(language);
    };

    // $scope.showSubscriptionDetail = () => {
    //     showProgress(true, progressText);
    //     google.script.run.withSuccessHandler((text) => {
    //         if (text == null) {
    //             showError(true, 'There was an error while loading this page');
    //         } else {
    //             const data = JSON.parse(text);
    //             $scope.is_renew_toggle_available = true;
    //             $scope.cancel_at_period_end = false;
    //             $scope.subscriptionDaysLeft = null;
    //             $scope.subscriptionExpiryDate = null;

    //             if (data.cancel_at_period_end != null) {
    //                 $scope.cancel_at_period_end = !data.cancel_at_period_end;
    //             } else {
    //                 $scope.is_renew_toggle_available = false;
    //             }

    //             if (data.subscription_due_on != null) {
    //                 $scope.subscriptionDaysLeft = data.subscription_days_left;

    //                 const date = new Date(data.subscription_due_on.replace(' ', 'T'));
    //                 const months = ['Jan', 'Feb', 'Mar', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    //                 const ampm = date.getHours() >= 12 ? 'pm' : 'am';

    //                 let minutes = date.getMinutes();
    //                 if (minutes < 10) {
    //                     minutes = `0${minutes}`;
    //                 }

    //                 $timeout(() => {
    //                     $scope.subscriptionExpiryDate = `${months[date.getMonth()]} ${date.getDate().toString()}, ${date.getFullYear().toString()} at ${date.getHours()}:${minutes} ${ampm}`;
    //                 });
    //             }

    //             showProgress(false, '');
    //             subscriptionInfoDialog.open();

    //             if ($scope.is_renew_toggle_available) {
    //                 elementCancelSub = mdc.switchControl.MDCSwitch.attachTo(document.querySelector('#cancel-subscription-switch'));
    //                 elementCancelSub.checked = $scope.cancel_at_period_end;
    //             }
    //         }
    //     }).withFailureHandler(errorHandler).getSubscriptionData($scope.toolId, $scope.serverToken);
    // };

    $scope.cancel_at_period_end_change = () => {
        // google.script.run.withSuccessHandler(() => { }).renewSubscriptionToggle(elementCancelSub.checked, $scope.toolId, $scope.serverToken);
    };

    $scope.snackBarUtil = (show, messageText, actionText) => {

        // if (!$scope.alert_multi_account) {
        //     return;
        // }

        $scope.launchSnackBar(messageText, actionText, show);
    };

    // $scope.handleDefaultValueEvent = () => {
    //     google.script.run
    //         .withSuccessHandler(() => { }).setAddonDefaults($scope.language, $scope.initValueAudio, elementPlaceholder.checked, $scope.serverToken);
    // };

    $scope.reloadCurrentPage = () => {
        $state.go($state.current.name, {}, { reload: true });
    };

    // $scope.onUploadClicked = () => {
    //     document.getElementById('uploadFile').value = null;
    //     document.querySelector('#uploadFile').click();
    // };

    // $scope.onFileSelected = (e) => {
    //     $log.info('onFileSelected');
    //     const sizeInMb = e.target.files[0].size / (1024 * 1024);
    //     const fileType = e.target.files[0].type;

    //     if (fileType === 'image/png' || fileType === 'image/jpg' || fileType === 'image/jpeg') {
    //         if (sizeInMb > 10) {
    //             $scope.launchSnackBar('Please select another image (Max size 10 Mb)', 'Ok', true);
    //         } else {

    //             google.script.run.withSuccessHandler(() => { }).gABasicEvent('upload_image_selected', {
    //                 username: $scope.userEmail,
    //                 toolName: 'graphic-organizers',
    //                 pageName: 'graphic-organizers'
    //             }, $scope.serverToken);

    //             showProgress(true, 'Uploading file...');

    //             const imageFile = e.target.files[0];
    //             const uploadFile = new Promise((resolve, reject) => {
    //                 // eslint-disable-next-line no-undef
    //                 const reader = new FileReader();

    //                 reader.onload = (f) => {
    //                     resolve({
    //                         filename: `${imageFile.name.split('.')[0]}.png`,
    //                         mimeType: 'image/png',
    //                         bytes: [...new Int8Array(f.target.result)],
    //                     });
    //                 };

    //                 reader.onerror = (err) => {
    //                     reject(err);
    //                 };
    //                 reader.readAsArrayBuffer(imageFile);
    //             });
    //             uploadFile.then((fileObject) => {
    //                 google.script.run
    //                     .withSuccessHandler((success) => {
    //                         const responseData = JSON.parse(success);

    //                         google.script.run.withSuccessHandler(() => { }).gABasicEvent('image_uploaded', {
    //                             username: $scope.userEmail,
    //                             url: responseData.url,
    //                             toolName: 'graphic-organizers',
    //                             pageName: 'graphic-organizers'
    //                         });

    //                         google.script.run
    //                             .withSuccessHandler((slideId) => {
    //                                 if (slideId == null) {
    //                                     showError(true, ERROR_MESSAGE);
    //                                 } else {
    //                                     insertText(slideId, null, responseData);

    //                                     google.script.run.withSuccessHandler(() => { }).gABasicEvent('custom_graphic_organizer_added', {
    //                                         username: $scope.userEmail,
    //                                         url: responseData.url,
    //                                         textboxCount: responseData.textboxes.length,
    //                                         toolName: 'graphic-organizers',
    //                                         pageName: 'graphic-organizers'
    //                                     });
    //                                 }
    //                             })
    //                             .withFailureHandler(errorHandler)
    //                             .insertBackground(responseData.url, presentationId);
    //                     })
    //                     .withFailureHandler(errorHandler)
    //                     .uploadImage(fileObject, $scope.serverToken);
    //             }).catch((err) => {
    //                 $log.error(err);
    //             });
    //         }
    //     } else {
    //         $scope.launchSnackBar('Please select another image (JPG, PNG)', 'Ok', true);
    //     }
    // };

    function getTextBoxes(canvasId, language) {
        try {
            if (language === 'es') {
                const esBundles = getGraphicOrganizerData().bundles.filter(bundle => bundle.language === 'es');
                const bundleWithCanvash = esBundles.filter(bundle => bundle.canvas_list.filter(canvas => canvas.canvas_id === canvasId)[0]);
                return bundleWithCanvash[0].canvas_list.filter(canvas => canvas.canvas_id === canvasId)[0].textbox;
            }

            const enBundles = getGraphicOrganizerData().bundles.filter(bundle => bundle.language === 'en');
            const bundleWithCanvash = enBundles.filter(bundle => bundle.canvas_list.filter(canvas => canvas.canvas_id === canvasId)[0]);
            return bundleWithCanvash[0].canvas_list.filter(canvas => canvas.canvas_id === canvasId)[0].textbox;
        } catch (e) {
            Logger.log(`Error in getTextBoxes: ${e.toString()}`);
            return null;
        }
    }

    $scope.pageSizeHideShowToggleView = (value) => {
        $scope.pageSizeHideShowToggle = value;
    }
};